import { FiArrowUpRight } from 'react-icons/fi';

const CTAButton = ({ 
  children = 'Start Your Project', 
  onClick, 
  className = '',
  icon: Icon = FiArrowUpRight,
  iconSize = 18,
  variant = 'default'
}) => {
  const baseClasses = 'rounded-full pl-5 pr-6 py-3 font-semibold transition-all duration-200 cursor-pointer border-0 inline-flex items-center gap-3 font-montserrat';
  
  if (variant === 'dark') {
    return (
      <button
        onClick={onClick}
        className={`${baseClasses} bg-slate-900 text-white hover:bg-slate-800 active:scale-95 group ${className}`}
      >
        <span className="w-8 h-8 bg-[#d6fa70] rounded-full flex items-center justify-center flex-shrink-0 transition-transform duration-200 group-hover:scale-110">
          <Icon size={iconSize} className="text-slate-900" />
        </span>
        {children}
      </button>
    );
  }

  return (
    <button
      onClick={onClick}
      className={`${baseClasses} bg-[#d6fa70] text-slate-900 hover:bg-[#c9f050] active:scale-95 group ${className}`}
    >
      <span className="w-8 h-8 bg-slate-900 rounded-full flex items-center justify-center flex-shrink-0 transition-transform duration-200 group-hover:scale-110">
        <Icon size={iconSize} className="text-[#d6fa70]" />
      </span>
      {children}
    </button>
  );
};

export default CTAButton;
